import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FruHttpService } from '../../../../services/fru-http.service';
import { OfficeStatus } from '../../../../shared/office-status';
import { PremiumQuestions } from '../../../../shared/premium-questions';

@Component({
    selector: 'app-premium-questions',
    templateUrl: './premium-questions.component.html',
    styleUrls: ['./premium-questions.component.scss'],
    standalone: false
})

export class PremiumQuestionsComponent implements OnInit {
	@Input() premiumQuestions: PremiumQuestions;
	@Input() leadId: string;

	public officeStatus: OfficeStatus;
	public showError: boolean = false;
	public errorMessage: string = '';
	public currentYear: number = 2023;

	constructor(private fruHttp: FruHttpService, private route: ActivatedRoute) { }

	ngOnInit() {
		let d = new Date();
    	this.currentYear = d.getFullYear();

		this.route.queryParams.subscribe(params =>
			this.fruHttp
				.getOfficeStatus(params.utm_source || 'consumer_campaign')
				.subscribe(officeStatus => this.officeStatus = officeStatus)
		);

		this.getPremiumQuestions();
	}

	getPremiumQuestions() {
		this.leadId = this.route.snapshot.paramMap.get('id');

		if (! this.leadId) {
			this.showError = true;
			this.errorMessage = 'This is not a valid URL, please use the link provided and try again.';
		} else {
			this.fruHttp.getPremiumQuestions(this.leadId).subscribe(premiumQuestions => {
				this.premiumQuestions = premiumQuestions;

				if (Object.keys(this.premiumQuestions).length === 0) {
					this.showError = true;
				}
			});
		}
	}
}
